import { gql } from "generated-graphql";

export const LOOKUP_RECORD_BY_UUID = gql(`
  query LookupRecordByUuid($uuid: ID!) {
    lookupRecordByUuid(uuid: $uuid) {
      record
      tableName
      id
      recordName
      tenantId
      tenantName
      facilityId
      facilityName
      reportId
      chemicalId
      productId
      reportingYear
      workflowId
      auditEntries {
        operation
        timestamp
        record
        oldRecord
        userEmail
      }
      errors
    }
  }
`);

export const LOAD_MORE_AUDIT_ENTRIES = gql(`
  query LoadMoreAuditEntries($uuid: ID!, $offset: Int!) {
    loadMoreAuditEntries(uuid: $uuid, offset: $offset) {
      operation
      timestamp
      record
      oldRecord
      userEmail
    }
  }
`);
